import React from 'react';
import { User } from 'resources';

import { Button, Alert } from 'react-bootstrap';

export default class UnsubscribeIndex extends React.Component {

  state = {
    email: null,
    unsubscribed: false,
    saving: false,
  }

  constructor(props) {
    super(props);

    this.state.email = props.location.query.email;
  }

  doUnsubscribe = (e) => {
    e.preventDefault();

    const { email } = this.state;

    this.setState({ saving: true });

    User.unsubscribe({
      data: {
        email,
      },
      onSuccess: () => this.setState({ unsubscribed: true }),
      onFailure: ({ data }) => {
        const error = _.get(data, 'user.email');
        this.setState({ error, saving: false });
      },
    });

  }

  updateEmail = (e) => {
    const { value } = e.target;
    this.setState({ email: value, error: false });
  }

  renderUnsubscribed = () => (
    <div className="account-wrapper">
      <h3>Done!</h3>
      <Alert bsStyle="success">
        {this.state.email} has been unsubscribed from emails.
      </Alert>
    </div>
  )

  render() {
    const { email, unsubscribed, saving, error } = this.state;

    if (unsubscribed) {
      return this.renderUnsubscribed();
    }

    return (
      <div className="account-wrapper">

        <h3>Sorry to bother you!</h3>

        <form
          className="form account-form account-body"
          onSubmit={this.doUnsubscribe}
          autoComplete="off"
        >

          <div className="form-group">
            <input
              type="text"
              name="email"
              defaultValue={email}
              onChange={this.updateEmail}
              className="form-control"
              placeholder="Email"
              tabIndex="1"
            />
            {error && <strong className="help-block text-danger">{error}</strong>}
          </div>

          <div className="form-group">
            <Button
              type="submit"
              bsStyle="primary"
              block
              tabIndex="4"
              disabled={saving}
            >
              Unsubscribe from all emails
            </Button>
          </div>

        </form>

      </div>
    );
  }

}
